import Box from "@mui/material/Box";

export const CardRounded = ({children, sx, ...props}) => {
  return (
    <Box {...props} sx={{borderRadius: 5, ...sx}}>
      {children}
    </Box>
  )
}